import { render, staticRenderFns } from "./alert-setting.vue?vue&type=template&id=2f37dce2&scoped=true&"
import script from "./alert-setting.vue?vue&type=script&lang=tsx&"
export * from "./alert-setting.vue?vue&type=script&lang=tsx&"
import style0 from "./alert-setting.vue?vue&type=style&index=0&id=2f37dce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37dce2",
  null
  
)

export default component.exports